import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.queryDefinition],
        config: {
            headerName: getLocalizedString("locationGroup"),
            field: "group",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.queryDefinition],
        config: {
            headerName: getLocalizedString("groupAppearanceSequence"),
            field: "sequence",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinition],
        config: {
            headerName: getLocalizedString("activeFemale"),
            field: "activeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinition],
        config: {
            headerName: getLocalizedString("queryCode"),
            field: "code",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinition],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinition],
        config: {
            headerName: getLocalizedString("visualizationRol"),
            field: "rolString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinition],
        config: {
            headerName: getLocalizedString("contextInformation"),
            field: "hasContext",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.queryDefinition],
        config: {
            headerName: getLocalizedString("builtWithAI"),
            field: "isAiGeneratedString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["queryDefinitionQuestions"],
        config: {
            headerName: getLocalizedString("order"),
            field: "order",
            filter: false,
            checkboxSelection: true,
            headerCheckboxSelection: true,
        }
    },
    {
        pages: ["queryDefinitionQuestions"],
        config: {
            headerName: getLocalizedString("question"),
            field: "question",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["queryDefinitionAiParameters"],
        config: {
            headerName: getLocalizedString("parameterNumber"),
            field: "paramNum",
            filter: false,
            checkboxSelection: true,
            headerCheckboxSelection: true,
        }
    },
    {
        pages: ["queryDefinitionAiParameters"],
        config: {
            headerName: getLocalizedString("parameterName"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["queryDefinitionAiParameters"],
        config: {
            headerName: getLocalizedString("parameterType"),
            field: "paramTypeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["queryDefinitionAiParameters"],
        config: {
            headerName: getLocalizedString("parameterListSelectorType"),
            field: "listTypeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["queryDefinitionAiParameters"],
        config: {
            headerName: getLocalizedString("annexRequired"),
            field: "requireString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["queryDefinitionAiParameters"],
        config: {
            headerName: getLocalizedString("testValueForParameter"),
            field: "value",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["queryDefinitionAiParameters"],
        config: {
            headerName: getLocalizedString("sqlToDetermineValueListForParameter"),
            field: "sql",
            filter: "agTextColumnFilter",
        }
    },
];